import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { FormControlLabel, Switch } from '@material-ui/core';

const IOSSwitch = (props) => <Switch {...props} />;

const CookieManagementScreen = ({ setScreenNumber }) => {
  const [moreInfoOpen, setIsMoreInfoOpen] = useState(false);
  const [isOpenNecessaryCookies, setIsOpenNecessaryCookies] = useState(false);
  const [targetCookies, setTargetCookies] = useState(true);
  const [isOpenTargetCookies, setIsOpenTargetCookies] = useState(false);
  const [performanceCookies, setPerformanceCookies] = useState(true);
  const [isOpenPerformanceCookies, setIsOpenPerformanceCookies] =
    useState(false);
  const [trackingCookies, setTrackingCookies] = useState(true);
  const [isOpenTrackingCookies, setIsOpenTrackingCookies] = useState(false);
  const [operationalCookies, setOperationalCookies] = useState(true);
  const [isOpenOperationalCookies, setIsOpenOperationalCookies] =
    useState(false);

  const handleAcceptAllCookies = () => {
    setTargetCookies(true);
    setPerformanceCookies(true);
    setTrackingCookies(true);
    setOperationalCookies(true);
    setScreenNumber(1);
  };

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.headTitle}>Налаштування файлів cookie</p>
        <p className={styles.text}>
          {"Що таке cookies? Cookies - короткі комп'ютерні програми, написані в зрозумілому для людини тексті. Вони розміщуються на вашому пристрої під час відвідування сайту і використовуються для ідентифікації вашого пристрою для цілей описаних тут. \n\n" +
            'Файли cookie, встановлені власником сайту, називаються «cookie першої сторони». Файли cookie, встановлені іншими особами називають «сторонніми файлами cookie». Сторонні файли cookie дозволяють третій стороні надавати нам послуги, щоб ми могли забезпечувати функціональність сайту (наприклад, аналітику, рекламу та відео). Сторони, які встановлюють ці файли cookie можуть розпізнавати ваш пристрій як при відвідуванні нашого сайту, так і при відвідуванні деяких інших сайтів.'}
          {!moreInfoOpen && (
            <p
              className={styles.moreInfoButton}
              onClick={() => setIsMoreInfoOpen(true)}
            >
              Більше інформації
            </p>
          )}
          {moreInfoOpen
            ? '\n\nЦі файли cookie поділяються на три категорії. Ті, що у першій категорії - необхідні. Ті, що в інших двох категоріях є необов\'язковими: ви можете вирішувати, чи хочете ви отримати їх від нас, і ви можете використовувати цей інструмент, щоб встановлювати свої уподобання. Ви можете змінити свою думку в будь-який час, перейшовши за посиланням "Налаштування файлів cookie" з будь-якої сторінки сайту.'
            : ''}
        </p>
        <p className={styles.headTitle}>Керування налаштуваннями cookie</p>
        <div className={styles.tableWrapper}>
          <div className={styles.tableContainer}>
            <div
              className={styles.tableHead}
              style={isOpenNecessaryCookies ? { border: 'none' } : null}
            >
              <div
                className={styles.title}
                onClick={() =>
                  setIsOpenNecessaryCookies(!isOpenNecessaryCookies)
                }
              >
                <div className={styles.iconContainer}>
                  {!isOpenNecessaryCookies ? (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.27344 3.71094V5.54688H0.476562V3.71094H8.27344ZM5.36719 0.578125V8.85938H3.39062V0.578125H5.36719Z"
                        fill="#5617A0"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="6"
                      height="2"
                      viewBox="0 0 6 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginTop: -3 }}
                    >
                      <path
                        d="M5.03906 0.3125V1.94531H0.765625V0.3125H5.03906Z"
                        fill="#5617A0"
                      />
                    </svg>
                  )}
                </div>
                Обов'язкові необхідні cookie
              </div>
              <FormControlLabel
                control={<IOSSwitch checked={true} disabled />}
                style={{ margin: 0 }}
                label=""
              />
            </div>
            {isOpenNecessaryCookies && (
              <p className={styles.tableText}>
                Ці файли cookie необхідні для функціонування веб-сайту і не
                можуть бути відключені в наших системах. Зазвичай вони
                встановлюються тільки у відповідь на ваші дії, що призводять до
                запиту на послуги, такі як установка налаштувань
                конфіденційності, вхід в систему або заповнення форм. Ви можете
                налаштувати свій браузер так, щоб він блокував або попереджав
                вас про ці файли cookie, але деякі частини сайту можуть не
                працювати.
              </p>
            )}
            <div
              className={styles.tableHead}
              style={isOpenOperationalCookies ? { border: 'none' } : null}
            >
              <div
                className={styles.title}
                onClick={() =>
                  setIsOpenOperationalCookies(!isOpenOperationalCookies)
                }
              >
                <div className={styles.iconContainer}>
                  {!isOpenOperationalCookies ? (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.27344 3.71094V5.54688H0.476562V3.71094H8.27344ZM5.36719 0.578125V8.85938H3.39062V0.578125H5.36719Z"
                        fill="#5617A0"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="6"
                      height="2"
                      viewBox="0 0 6 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginTop: -3 }}
                    >
                      <path
                        d="M5.03906 0.3125V1.94531H0.765625V0.3125H5.03906Z"
                        fill="#5617A0"
                      />
                    </svg>
                  )}
                </div>
                Експлуатаційні cookie
              </div>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={operationalCookies}
                    onChange={() => setOperationalCookies(!operationalCookies)}
                  />
                }
                style={{ margin: 0 }}
                label=""
              />
            </div>
            {isOpenOperationalCookies && (
              <p className={styles.tableText}>
                Ці файли cookie необхідні для роботи веб-сайту або його функцій,
                які ви можете використовувати для зручності. Наприклад: щоб
                пам'ятати, хто ви, ваші уподобання та налаштування, щоб вам не
                потрібно було вводити їх щоразу, коли ви змінюєте сторінку; щоб
                правильно відображати вміст на пристрої; запобігати шахрайству
                (наприклад, щоб переконатися, що одна і та ж особа не виконує
                одне і те ж опитування двічі). Оскільки ці функції необхідні для
                нормальної роботи сайту, тому неможливо відмовитися від цього
                виду cookies. Тим не менш, якщо ви хочете, ви можете налаштувати
                свій браузер, щоб відхилити всі файли cookie, в цьому випадку
                сайт може не відображатися належним чином, і вибрані вами
                функції можуть бути недоступні.
              </p>
            )}
            <div
              className={styles.tableHead}
              style={isOpenPerformanceCookies ? { border: 'none' } : null}
            >
              <div
                className={styles.title}
                onClick={() =>
                  setIsOpenPerformanceCookies(!isOpenPerformanceCookies)
                }
              >
                <div className={styles.iconContainer}>
                  {!isOpenPerformanceCookies ? (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.27344 3.71094V5.54688H0.476562V3.71094H8.27344ZM5.36719 0.578125V8.85938H3.39062V0.578125H5.36719Z"
                        fill="#5617A0"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="6"
                      height="2"
                      viewBox="0 0 6 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginTop: -3 }}
                    >
                      <path
                        d="M5.03906 0.3125V1.94531H0.765625V0.3125H5.03906Z"
                        fill="#5617A0"
                      />
                    </svg>
                  )}
                </div>
                Файли cookie для продуктивності
              </div>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={performanceCookies}
                    onChange={() => setPerformanceCookies(!performanceCookies)}
                  />
                }
                style={{ margin: 0 }}
                label=""
              />
            </div>
            {isOpenPerformanceCookies && (
              <p className={styles.tableText}>
                Вони дозволяють зрозуміти, як люди в цілому (а не будь-яка
                фізична особа) використовують сайт, і наскільки добре сайт
                працює. У свою чергу, це дозволяє нам поліпшити спосіб роботи
                сайту. Для цього ми використовуємо ці технології розташовані,
                потім агреговані, і тільки тоді (коли з даних не можна
                виокремити конкретну особу) ми аналізуємо його. На ваш розсуд Ви
                можете вибрати або відмовитися від використання цих файлів
                cookie.
              </p>
            )}
            <div
              className={styles.tableHead}
              style={isOpenTrackingCookies ? { border: 'none' } : null}
            >
              <div
                className={styles.title}
                onClick={() => setIsOpenTrackingCookies(!isOpenTrackingCookies)}
              >
                <div className={styles.iconContainer}>
                  {!isOpenTrackingCookies ? (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.27344 3.71094V5.54688H0.476562V3.71094H8.27344ZM5.36719 0.578125V8.85938H3.39062V0.578125H5.36719Z"
                        fill="#5617A0"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="6"
                      height="2"
                      viewBox="0 0 6 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginTop: -3 }}
                    >
                      <path
                        d="M5.03906 0.3125V1.94531H0.765625V0.3125H5.03906Z"
                        fill="#5617A0"
                      />
                    </svg>
                  )}
                </div>
                Відстежуючі cookie
              </div>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={trackingCookies}
                    onChange={() => setTrackingCookies(!trackingCookies)}
                  />
                }
                style={{ margin: 0 }}
                label=""
              />
            </div>
            {isOpenTrackingCookies && (
              <p className={styles.tableText}>
                {'Ці файли cookie відстежують ваше використання нашого сайту та інших сайтів. Чому і як ми їх використовуємо. Перш за все ми хочемо, щоб ви насолоджувалися вашою взаємодією з нами: ми адаптуємо наші пропозиції відповідно до вашого досвіду з нами та ваших інтересів, наприклад, щоб:\n' +
                  'дати вам персоналізований досвід взаємодії з нами, наприклад, ваші дзвінки в колл-центри, ваші візити в наші магазини та відвідування наших інтернет-сайтів чи мобільних додатків; \n' +
                  'персоналізувати наші оголошення, контент і комунікації; \n' +
                  'зафіксувати ваш регулярний інтерес до наших брендів. \n\n' +
                  "Ці файли cookie відіграють важливу роль у цьому. Як це працює? Ми слідкуємо за тим як ви з нами взаємодієте. Наприклад, ми відзначаємо, що ви купуєте у нас, і як обробляються ваші дзвінки в центрі обробки викликів клієнтів. Ми використовуємо пікселі відстеження (де ви це дозволяєте), щоб відзначити, які електронні комунікації від нас ви відкриваєте, і які посилання в них ви натискаєте. Крім того, якщо ви погоджуєтеся на це на цьому веб-сайті або на іншому нашому веб-сайті, ми використовуємо файли cookie (та подібні технології) в електронному вигляді, щоб слідкувати за тим, як ви використовуєте наші та певні сторонні веб-сайти та мобільні додатки. На останок, ми об'єднуємо наші знання з усіх цих каналів (наскільки ми можемо; наприклад, якщо ви не перебуваєте в одній з наших баз даних, ми менш ймовірно зможемо це зробити), щоб створити картину ваших уподобань і того, що вас цікавить. Ви можете вибрати або відмовитися від нашого використання цих файлів cookie на ваш розсуд."}
              </p>
            )}
            <div
              className={styles.tableHead}
              style={isOpenTargetCookies ? { border: 'none' } : null}
            >
              <div
                className={styles.title}
                onClick={() => setIsOpenTargetCookies(!isOpenTargetCookies)}
              >
                <div className={styles.iconContainer}>
                  {!isOpenTargetCookies ? (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.27344 3.71094V5.54688H0.476562V3.71094H8.27344ZM5.36719 0.578125V8.85938H3.39062V0.578125H5.36719Z"
                        fill="#5617A0"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="6"
                      height="2"
                      viewBox="0 0 6 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginTop: -3 }}
                    >
                      <path
                        d="M5.03906 0.3125V1.94531H0.765625V0.3125H5.03906Z"
                        fill="#5617A0"
                      />
                    </svg>
                  )}
                </div>
                Цільові cookies
              </div>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={targetCookies}
                    onChange={() => setTargetCookies(!targetCookies)}
                  />
                }
                style={{ margin: 0 }}
                label=""
              />
            </div>
            {isOpenTargetCookies && (
              <p className={styles.tableText}>
                Ці файли cookie встановлюються через наш сайт нашими рекламними
                партнерами. Вони можуть використовуватися цими компаніями для
                створення профілю ваших інтересів і показу вам релевантних
                оголошень на інших сайтах. Вони працюють, унікально
                ідентифікуючи ваш браузер і пристрій. Якщо ви не дозволите
                використання цих файлів cookie, ви не побачите нашу цільову
                комунікацію на різних сайтах.
              </p>
            )}
          </div>
        </div>
        <div
          className={styles.buttonContainer}
          onClick={handleAcceptAllCookies}
        >
          <button>Погоджуюся з усім</button>
        </div>
      </div>
      <div className={styles.footerContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(9)}>Умови використання</button>
        <button onClick={() => setScreenNumber(10)}>FAQ</button>
        <button onClick={() => setScreenNumber(11)}>
          Параметри застосування файлів cookie
        </button>
      </div>
    </div>
  );
};

export default CookieManagementScreen;
